import { LgkNavMenuItem } from "@logick/ui/api"

export const USER_ACCOUNT_MENU: LgkNavMenuItem = {
    label: "Mon Compte",
    routerLink: "user-account",
    visible: false,
    routing: { loadComponent: () => import("./account.page").then((it) => it.AccountPage) }
}